/*
 * Copyright 2024 StarTree Inc.
 *
 * All rights reserved. Confidential and proprietary information of StarTree Inc.
 */
import create from "zustand";
import { persist } from "zustand/middleware";
import { WorkspaceData } from "../rest/workspace.rest";

export const WORKSPACE_PROVIDER_LOCAL_STORAGE_KEY =
    "workspace-provider-context";

export interface WorkspaceProviderStore {
    selectedWorkspace: WorkspaceData;
    setSelectedWorkspace: (workspace: WorkspaceData) => void;
}

export const useWorkspaceProviderStore = create<WorkspaceProviderStore>(
    persist(
        (set) => ({
            selectedWorkspace: {} as WorkspaceData,
            setSelectedWorkspace: (selectedWorkspace: WorkspaceData) => {
                set((state) => {
                    return {
                        ...state,
                        selectedWorkspace: selectedWorkspace || {},
                    };
                });
            },
        }),
        {
            name: WORKSPACE_PROVIDER_LOCAL_STORAGE_KEY, // Persist in browser local storage
        }
    )
);
